import Glide from '@glidejs/glide';

document.addEventListener('DOMContentLoaded', () => {
  const slider = new Glide('.features-list', {
    perView: 2,
    breakpoints: {
      600: {
        perView: 1,
      },
    },
  });

  if (window.innerWidth < 767) {
    slider.mount();
  } else {
    slider.destroy();
  }
});
